import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react"

const API2_URL = process.env.REACT_APP_API2_ENDPOINT

export const apiV2 = createApi({
  reducerPath: "apiV2",
  baseQuery: fetchBaseQuery({
    baseUrl: API2_URL,
    prepareHeaders: (headers) => {
      let token = localStorage.getItem("authUser")
      if (token) {
        token = token.replace('"', "").replace('"', "")
        headers.set("Authorization", `Bearer ${token}`)
      }
      headers.set("Content-Type", "application/json")
      headers.set("Accept", "application/json")
      return headers
    },
  }),
  endpoints: () => ({}),
})
